import {Injectable} from '@angular/core';
import {Subject, BehaviorSubject} from "rxjs";
import {JwtHelper} from 'angular2-jwt';

@Injectable()
export class DataService {
    private loggedUserObs$ = new Subject();
    private activeRequestNo = new BehaviorSubject(0);

    jwtHelper: JwtHelper = new JwtHelper();

    constructor() {
    }

    getActiveRequestNo() {
        return this.activeRequestNo;
    }

    resetActiveRequestNo() {
        this.activeRequestNo.next(0);
    }

    updateActiveRequestNo(value) {
        var prevValue;
        this.activeRequestNo.subscribe((value)=>prevValue = value);
        this.activeRequestNo.next(prevValue + value);
    }

    getLoggedUser() {
        return this.loggedUserObs$;
    }

    updateLoggedUser() {
        var token = localStorage.getItem('token');
        this.loggedUserObs$.next(this.jwtHelper.decodeToken(token).user);
    }

    refresh() {
        this.activeRequestNo.next(0);
        this.updateLoggedUser();
    }

    checkPermission(module, method) {
        var permission = JSON.parse(localStorage.getItem('permission'));
        if (method == 'ALL') {
            if (permission[module]['GET'] == 1 ||
                permission[module]['POST'] == 1 ||
                permission[module]['PUT'] == 1 ||
                permission[module]['DELETE'] == 1) {
                return true;
            }
        }
        if (permission[module][method] == 1) {
            return true;
        }
        return false;
    }

}



// WEBPACK FOOTER //
// ./src/app/services/data.service.ts